module.exports = __webpack_public_path__ + "static/media/physiowerk-logo-mobile.91886bb6.svg";